<template>
    <div v-if="hasTabs" class="tabs-container">
        <button
            v-for="tab in tabs"
            :key="tab.value"
            :class="['tabs-button', tab.value === active && 'selected']"
            :onClick="() => onChange(tab.value)"
            type="button">
            {{ tab.label }}
        </button>
    </div>
</template>

<script lang="ts">
    import { computed, defineComponent, PropType } from 'vue';
    import { TabButton } from './Tabs.interfaces';
    import { isEmpty } from 'lodash';

    export default defineComponent({
        name: 'Tabs',
        props: {
            tabs: {
                type: Array as PropType<TabButton[]>,
                default: () => [],
            },
            active: {
                type: String as PropType<string | null>,
            },
            onChange: {
                type: Function as PropType<(value: string) => void>,
                required: true,
            },
        },
        setup(props) {
            const hasTabs = computed(() => !isEmpty(props.tabs));
            return { hasTabs };
        },
    });
</script>

<style lang="scss" scoped>
    @forward './Tabs.scss';
</style>
